import Assert from "tbAssert";

import UiRouterModule from "@uirouter/angularjs";
import AuthSvcModule from "tbClient/services/auth";

import TbAppConstants from "tbClient/config/tbAppConstants";
import AuthCallbackViewModuleConstants from "tbClient/views/auth-callback/Constants";
import TbLoginViewModuleConstants from "tbClient/views/tb-login-view/Constants";

import DependencyListBuilder from "tbClient/utility/DependencyListBuilder";

const stateRequiresAuthCriteria = {
    to: (state) => state.data && (state.data.requiresLogin === true)
};

const exitingAuthCallbackCriteria = {
    to: (state) => (state.name !== TbLoginViewModuleConstants.rootStateName),
    exiting: AuthCallbackViewModuleConstants.rootStateName
};


function ConfigureRequireAuthHook($transitions, $log) {

    const loginInterceptStateNameKey = `${TbAppConstants.loginInterceptState}_Name`;
    const loginInterceptStateParamsKey = `${TbAppConstants.loginInterceptState}_Params`;

    const redirectNonAuthenticatedToLogin = (transition) => {
        const authSvc = transition.injector().get("TbAuthService");
        if (!authSvc.isAuthenticated()) {
            // State requires login and user is not authenticated: send to login state

            const originalTargetState = transition.targetState();
            const originalTargetStateName = originalTargetState.name();
            Assert.StrictAssert(
                originalTargetStateName !== TbLoginViewModuleConstants.rootStateName,
                "Assumption Violated: redirected to auth when transiting to login state"
            );
            Assert.StrictAssert(
                originalTargetStateName !== AuthCallbackViewModuleConstants.rootStateName,
                "Assumption Violated: redirected to auth when transiting to auth callback state"
            );

            const originalTargetStateParams = JSON.stringify(originalTargetState.params());
            try {
                localStorage.setItem(loginInterceptStateNameKey, originalTargetStateName);
                localStorage.setItem(loginInterceptStateParamsKey, originalTargetStateParams);

                $log.debug("Saved pre-auth redirect state name", originalTargetStateName);
                $log.debug("Saved pre-auth redirect state params", originalTargetStateParams);
            }
            catch(e) {
                $log.warning("Unable to save state in local storage. You may be unable to save access tokens, which will prevent your use of this site.", e);
            }

            return transition.router.stateService.target(TbLoginViewModuleConstants.rootStateName);
        }
    };

    $transitions.onBefore(stateRequiresAuthCriteria, redirectNonAuthenticatedToLogin, {priority: 80});

    const redirectAfterLoginToOriginalDestination = (transition) => {
        $log.debug("Reading pre-auth redirect original state");
        const originalStateName = localStorage.getItem(loginInterceptStateNameKey);
        const originalStateParams = JSON.parse(localStorage.getItem(loginInterceptStateParamsKey));

        if (originalStateName != null) {
            localStorage.removeItem(loginInterceptStateNameKey);
            localStorage.removeItem(loginInterceptStateParamsKey);
            const originalState = transition.router.stateService.target(originalStateName, originalStateParams);
            $log.debug("Retrieved pre-auth redirect original state", originalState);
            if (originalState.valid()) {
                $log.debug("Pre-auth redirect state was valid, going there");
                return originalState;
            }
        }

        $log.debug("Pre-login state either not found or invalid");
    };

    $transitions.onExit(exitingAuthCallbackCriteria, redirectAfterLoginToOriginalDestination, { priority: 50 });
}

ConfigureRequireAuthHook.$inject = ["$transitions", "$log"];

ConfigureRequireAuthHook.dependencies = DependencyListBuilder([
    UiRouterModule,
    AuthSvcModule
]);

export default ConfigureRequireAuthHook;



//////////////////
// WEBPACK FOOTER
// ./src/hooks/RequireAuthHook.js
// module id = plW9
// module chunks = 1